export default __webpack_public_path__ + "static/media/camaras.174294cc.pdf";